import { Stack } from 'expo-router';

/**
 * Route planner stack: wizard (index) + full-screen route map.
 */
export default function RoutePlannerLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" options={{ title: 'Route Planner', headerShown: true }} />
      <Stack.Screen name="map" options={{ title: "Today's Route", headerShown: true }} />
    </Stack>
  );
}
